import styled from '@emotion/styled';

import Table from '@app/components/Table';
import theme from '@app/styles/theme';

export const PricesTable = styled(Table)`
  & tbody {
    padding: 0 0.8rem;
    line-height: 1.5;
    background-color: ${theme.colors.lighterGray};

    & td {
      font-weight: 800;
      border: none;
      text-align: left;
      padding: 1rem 0;
    }

    & [data-table='simple-row-value'] {
      text-align: end;
    }

    & [data-table='whats-new-savings-price'] {
      color: ${theme.colors.gradientGreen};
    }

    & [data-table='simple-row-full-price-value'] {
      text-align: end;
      text-decoration: line-through;
    }

    & [data-table='whats-new-full-price'],
    & [data-table='whats-new-upgrade-price'] {
      td {
        border-bottom: 1px solid ${theme.colors.lightGray};
      }
    }
  }
`;

PricesTable.defaultProps = { alternateRows: false };
